import React, { useEffect, useRef, useState } from "react";
import Authenticated from "@/Layouts/Authenticated";
import { useForm, usePage } from "@inertiajs/inertia-react";
import { Inertia } from "@inertiajs/inertia";
import PageHeading from "@/Components/PageHeading";
import LoadingButton from "@/Components/LoadingButton";

import DataTables from "datatables.net/js/jquery.dataTables.min";
import "datatables.net-select";
import "datatables.net-searchbuilder";
import "jquery-datatables-checkboxes";
import "datatables.net-responsive";

const AdvanceAlert = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Advance Alert", route: null },
    ];

    const advanceFeeTable = useRef(null);

    const [datatable, setDatatable] = useState(null);

    const { errors } = usePage().props;

    const { processing } = useForm();

    useEffect(() => {
        setDatatable(
            new DataTables(advanceFeeTable.current, {
                processing: true,
                serverSide: true,
                retrieve: true,
                autoWidth: false,
                searchDelay: 1000,
                responsive: true,
                select: {
                    style: "multi",
                },
                dom: "<'dt-header'lf>t<'dt-footer'ip>",
                ajax: `${route("fees.datatable")}`,
                pageLength: 50,
                language: {
                    lengthMenu: "Show Entries _MENU_",
                },
                orderMulti: false,
                columns: [
                    {
                        data: "id",
                        name: "students.id",
                        orderable: false,
                        searchable: false,
                        className: "dt-tr-first",
                    },
                    { data: "registration_no", className: "dt-tr" },
                    {
                        data: "name",
                        name: "students.name",
                        className: "dt-tr",
                    },
                    {
                        data: "contact",
                        name: "students.contact",
                        className: "dt-tr",
                    },
                    {
                        data: "net_total",
                        name: "latestFee.net_total",
                        className: "dt-tr",
                        searchable: false,
                    },
                ],
                columnDefs: [
                    {
                        targets: 0,
                        checkboxes: {
                            selectRow: true,
                            selectAll: true,
                        },
                    },
                ],
                order: [[1, "asc"]],
            })
        );
    }, []);

    function handleSubmit(e) {
        e.preventDefault();

        console.log(datatable);

        Inertia.post(
            route("fees.alert.advance"),
            {
                selected: _.reduce(
                    datatable.column(0).checkboxes.selected(),
                    (result, value) => {
                        result.push(value);
                        return _.uniq(result);
                    },
                    []
                ),
            },
            {
                onSuccess: () => {
                    datatable.column(0).checkboxes.deselectAll();
                },
            }
        );
    }

    return (
        <div className="py-6">
            <PageHeading
                heading={"Fee Alert (Advance)"}
                breadcrumb={breadcrumb}
            />
            <div className="mt-2">
                <div className="mx-auto max-w-lg p-4">
                    <form onSubmit={handleSubmit}>
                        <div className={"flex flex-col items-center"}>
                            <div>
                                <LoadingButton
                                    type={"submit"}
                                    className={"btn-secondary"}
                                    loading={processing}
                                >
                                    Send Alert
                                </LoadingButton>
                            </div>
                            {errors.selected && (
                                <div className="text mt-1 text-sm font-normal text-red-600">
                                    <span>{errors.selected}</span>
                                </div>
                            )}
                        </div>
                    </form>
                </div>
            </div>
            <div className="mt-2">
                <div className="flex flex-col">
                    <div className="min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <div className="min-w-full bg-white p-2 shadow sm:rounded-lg">
                            <table
                                id="datatable"
                                className="mt-2 min-w-full divide-y divide-gray-200"
                                ref={advanceFeeTable}
                            >
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th scope={"col"} className="dt-th">
                                            #SN
                                        </th>
                                        <th scope={"col"} className="dt-th">
                                            Registration No
                                        </th>
                                        <th scope={"col"} className="dt-th">
                                            Student Name
                                        </th>
                                        <th scope={"col"} className="dt-th">
                                            Contact No
                                        </th>
                                        <th scope={"col"} className="dt-th">
                                            Remaining Balance
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        // <div
        //     id="main-content"
        //     className="relative h-full w-full overflow-y-auto"
        // >
        //     <main>
        //         <div className="block items-center justify-between border-b border-gray-200 bg-white p-4 sm:flex">
        //             <div className="mb-1 w-full">
        //                 <div className="mb-4">
        //                     <BreadCrumb
        //                         links={[
        //                             { name: "Home", route: "dashboard" },
        //                             { name: "Fees", route: "fees" },
        //                             { name: "Advance Alert", route: null },
        //                         ]}
        //                     />
        //                     <h1 className="text-xl font-semibold text-gray-900 sm:text-2xl">
        //                         Fees Alert (Advance)
        //                     </h1>
        //                 </div>
        //                 <div className="sm:flex">
        //                     <div className="mr-auto flex items-center space-x-2 sm:space-x-3">
        //                         <Link
        //                             className={
        //                                 "inline-flex w-1/2 items-center justify-center rounded-lg border border-gray-300 bg-white px-3 py-2 text-center text-sm font-medium text-gray-900 hover:bg-gray-100 focus:ring-4 focus:ring-cyan-200 sm:w-auto"
        //                             }
        //                         >
        //                             <svg
        //                                 xmlns="http://www.w3.org/2000/svg"
        //                                 className="-ml-1 mr-2 h-6 w-6"
        //                                 viewBox="0 0 20 20"
        //                                 fill="currentColor"
        //                             >
        //                                 <path
        //                                     fillRule="evenodd"
        //                                     d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
        //                                     clipRule="evenodd"
        //                                 />
        //                             </svg>
        //                             Back
        //                         </Link>
        //                     </div>
        //                     {errors.selected && (
        //                         <div className="text text-sm font-normal text-red-600">
        //                             <span>{errors.selected}</span>
        //                         </div>
        //                     )}
        //
        //                     <div className="ml-auto flex items-center space-x-2 sm:space-x-3">
        //                         <form onSubmit={handleSubmit} className="">
        //                             <LoadingButton
        //                                 type={"submit"}
        //                                 className={
        //                                     "inline-flex w-1/2 items-center justify-center rounded-lg border border-gray-300 bg-white px-3 py-2 text-center text-sm font-medium text-gray-900 hover:bg-gray-100 focus:ring-4 focus:ring-cyan-200 sm:w-auto"
        //                                 }
        //                                 loading={processing}
        //                             >
        //                                 Send Alert
        //                             </LoadingButton>
        //                         </form>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="flex items-center justify-center border-b border-gray-200 p-4">
        //             <div className="flex-grow p-2 shadow">
        //                 <table
        //                     id="datatable"
        //                     className="dataTable stripe cell-border min-w-full table-fixed divide-y divide-gray-200"
        //                 >
        //                     <thead className="bg-gray-600 text-center text-xs font-medium uppercase text-white">
        //                         <tr>
        //                             <th scope="col" className="p-4">
        //                                 #
        //                             </th>
        //                             <th scope="col" className="p-4">
        //                                 Name
        //                             </th>
        //                             <th scope="col" className="p-4">
        //                                 Contact
        //                             </th>
        //                             <th scope="col" className="p-4">
        //                                 Pending Balance
        //                             </th>
        //                         </tr>
        //                     </thead>
        //                 </table>
        //             </div>
        //         </div>
        //     </main>
        // </div>
    );
};

AdvanceAlert.layout = (page) => (
    <Authenticated title={"Fee Alert"} children={page} />
);

export default AdvanceAlert;
